import React, { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useTranslation, Trans } from "react-i18next";

import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";

import EditorComponent from "../../components/editorPageComponents/EditorComponent";
import Header from "../../components/header/Gnb";
import Breadcrumb from "../../components/header/BreadCrumb";
import Footer from "../../components/footer/FooterComponent";

import "../../assets/css/example.scss";
import changeLang from "../../utils/changeLanguage";

const WEBHWP_EXAMPLE = "webhwp-example";

function WebhwpExample() {
  const { lang } = useParams();
  const navigate = useNavigate();
  const { t } = useTranslation("translation");

  useEffect(() => {
    if (!(lang === "en-us" || lang === "" || lang === undefined)) {
      navigate(`/${WEBHWP_EXAMPLE}`);
    }
    changeLang(lang);
  }, [lang]);

  return (
    <Box id="example-page">
      <Header pageType={WEBHWP_EXAMPLE} />
      <Breadcrumb pageType={WEBHWP_EXAMPLE} />
      <Box className="ex-main">
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <Box className="webhwp-ex-title">
              <Box className="webhwp-ex-title-title">
                <b>{t("content.title.title")}</b>
              </Box>
              <Box className="webhwp-ex-title-desc">
                <Trans i18nKey="content.title.desc" ns="translation" />
              </Box>
            </Box>
          </Grid>
          <Grid item xs={12}>
            <EditorComponent />
          </Grid>
        </Grid>
      </Box>
      <Footer />
    </Box>
  );
}

export default WebhwpExample;
